import React, { Component } from "react";
import dotenv from 'dotenv';
import Helper from '../DevServices/Helper'
import { Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import { compose } from "redux";
import { 
    //thunkTest,
    t_api_req_device_list_by_user_role
} from "../../reducers/dev";
import DeviceList from "./DeviceList"
//import Xd from "./Xd"
/*
import Helper from "../LocServices/Helper"
import { login } from "../../actions/auth"; */
/* import { reqLocId_findInfo, 

} from "../../reducers/location"; */



dotenv.config();

class PageAllDevices_automat extends Component {
/*   constructor(props) {
    super(props);
    this.handlelocationId = this.handlelocationId.bind(this);
    this.onChangelocationId= this.onChangelocationId.bind(this);

    this.state = {
      //locationId: 0,
      isValidate: false,
      loading: false,
    };
  } */

  componentWillUnmount(){
    //console.log('Good Bye!')
/*     this.props.reset_LocIdInfo() */
  }
  
  componentDidMount(){
    //if (this.props.user) this.props.thunkTest(this.props.user.accessToken)
    if (this.props.user) this.props.t_api_req_device_list_by_user_role()  
      //console.log(process.env.REACT_APP_API, process.env.REACT_APP_PORT, process.env.REACT_APP_HOST)
/*     const loc_id = this.props.match.params?.loc_id
    let getRequest = true
    if (loc_id === "0") getRequest = false
    if (typeof(loc_id )== 'undefined') getRequest = false

    if (getRequest) {
      //console.log(`Log id: ${loc_id}`)
      this.props.reqLocId_findInfo(loc_id, this.props.user.chat_id, this.props.user.accessToken)
    } */
  }



  render() {
        // Check if the user is authenticated or exists
        if (!this.props.user) {
          // Redirect to an external URL
          //window.location.href = "https://google.com";
          window.location.href = process.env.REACT_APP_HOST+"/login";
          return null; // Return null to avoid rendering anything else
        }
    //if (this.props.user) return <Redirect to="/login" />;

    return (
    <div className="">



      <DeviceList 
        devList = {this.props.dev.devList.filter(v => v.type === "automat")}
      />

      <hr />
{/*       <button
        onClick={()=>{
          //Get hourly data
          this.props.thunkTest(this.props.user.accessToken)
        }}
      >Click Me2</button>   */}


      <Helper props={this.props} />
      
    </div>
    );
  }
}

function mapStateToProps(state) {
  //console.log(state)
  const { user, test } = state.auth;

  return {
    user,
    test,
    dev: state.dev,
/*    location: state.location */
  };
}

  const mapDispatchToProps = { 
    //thunkTest,
    t_api_req_device_list_by_user_role
  }



export default compose(
  connect(mapStateToProps, mapDispatchToProps)
  //withAuthRedirect
)(PageAllDevices_automat);

//connect(mapStateToProps, mapDispatchToProps)(PageSimpleFinder);

// Function to add time to a starting time
function addTimeToStartTime(startHour, startMinute, duration) {
  // Create a new Date object for the starting time (7 AM)
  const startTime = new Date();
  startTime.setHours(startHour, startMinute, 0, 0); // Set to 7 AM

  // Duration to add (2 hours, 30 minutes, 5 seconds)
  const { hours, minutes, seconds } = duration;

  // Add the duration to the start time
  startTime.setHours(startTime.getHours() + hours);
  startTime.setMinutes(startTime.getMinutes() + minutes);
  startTime.setSeconds(startTime.getSeconds() + seconds);

  // Return the new time
  return startTime;
}

// Define the starting time (7 AM) and the duration (2 hours, 30 minutes, 5 seconds)
const startHour = 7; // 7 AM
const startMinute = 0; // 0 minutes
const duration = {
  hours: 2,
  minutes: 30,
  seconds: 5
};

// Calculate the new time
const newTime = addTimeToStartTime(startHour, startMinute, duration);
